import PropTypes from 'prop-types'

const IdName = {
  id: PropTypes.number,
  name: PropTypes.string
}

export const SupplierShape = PropTypes.shape(IdName)

export const ContractShape = PropTypes.shape({
  ...IdName,
  expired: PropTypes.bool
})

export const ContractVehicleShape = PropTypes.shape({
  ...IdName,
  contracts: PropTypes.arrayOf(ContractShape)
})

export const ContractVehiclesShape = PropTypes.arrayOf(ContractVehicleShape)
